import { initialCacheState } from '@/app/store/slices/cacheSlice';

import type { CacheState } from '@/app/store/slices/cacheSlice';
import type { RootState } from '@/app/store/store';

const selectShellCacheSnapshot = (cache: CacheState) => ({
    countries: cache.countries,
    languages: cache.languages,
    servicePoint: cache.servicePoint,
    loginCountryLanguage: cache.loginCountryLanguage,
});

/**
 * Only restore the minimum dashboard shell state required after login.
 * Feature workflow slices should re-initialize on demand when the user enters
 * those modules, rather than being replayed into a duplicated tab.
 */
export const selectStateSnapshotSlices = (state: RootState) => ({
    authStore: state.authStore,
    servicePointProfile: state.servicePointProfile,
    cache: selectShellCacheSnapshot(state.cache),
});

/**
 * Rehydrates the partial shell cache snapshot back onto the full cache shape
 * expected by the Redux slice.
 */
export const hydrateStateSnapshotCache = (
    cache?: Partial<ReturnType<typeof selectShellCacheSnapshot>>,
): CacheState => ({
    ...initialCacheState,
    ...cache,
});
